import { createSlice } from "@reduxjs/toolkit";
import { fetchMembersItems } from "./MembersThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const membersSlice = createSlice({
  name: "members",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchMembersItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMembersItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchMembersItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default membersSlice.reducer;